import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { FlyoutContextProvider } from "@/components/General/Flyout/context/flyout.context";
import { Overlay } from "@/components/General/Overlay/overlay";

type Props = {
    open: boolean;
    container?: Element | DocumentFragment | null;
    overlayHeader?: boolean;
    className?: string;
    fullWidth?: boolean;
    onClose: () => void;
    children: ReactNode;
};

export const Base = ({
    open,
    container,
    className,
    overlayHeader = true,
    fullWidth = false,
    onClose,
    children,
    ...attributes
}: Props) => {
    return (
        <FlyoutContextProvider onClose={onClose}>
            <Overlay
                open={open}
                onClose={onClose}
                overlayHeader={overlayHeader}
                scrollLock={true}
            >
                <Overlay.Portal target={container}>
                    <Overlay.Content
                        className={cn("tw:h-full tw:w-full", {
                            "tw:max-w-100": !fullWidth
                        })}
                        positionAtMount={!overlayHeader}
                    >
                        <aside
                            className={cn(
                                "tw:absolute tw:w-full tw:h-full tw:pointer-events-auto tw:left-0 tw:flex tw:flex-col tw:bg-background!",
                                {
                                    "tw:-translate-x-full": !open,
                                    "tw:translate-x-0": open,
                                    "tw:max-w-100": !fullWidth
                                },
                                className
                            )}
                            {...attributes}
                        >
                            {children}
                        </aside>
                    </Overlay.Content>
                </Overlay.Portal>
            </Overlay>
        </FlyoutContextProvider>
    );
};
